// extracted by mini-css-extract-plugin
export var drawerContent = "_3d-0";
export var valueBlock = "_3d-1";
export var valueBlockFrom = "_3d-2 _3d-1";
export var valueBlockTo = "_3d-3 _3d-1";